import { AxiosResponse } from 'axios'

import { getRefreshToken, getAccessToken } from '../actions/token'
import { getAnonymousUser } from '../actions/user'
import { isDevMode } from '../envs/envs'
import { authApi, api } from '../https'
import { AccessRightsType } from '../types/servicesTypes/configTypes'
import { UserResponseType, UserResponseDataType, BasicUserCredentials } from '../types/servicesTypes/identityTypes'

export class Auth {
  static async getAccessRights(): Promise<AccessRightsType> {
    const res = await api.get<AccessRightsType>(`/v3/my/accessrights`)
    return res?.data
  }

  static async registerAnonymousUser(): Promise<BasicUserCredentials | false> {
    const res = await authApi.post<BasicUserCredentials>(`/tenants/sportworld/anonymous/register`)
    isDevMode && console.log('[sdk registerAnonymousUser]', res)

    return res.status === 200 && res.data
  }

  static async loginAnonymousUser(
    basicUserCredentials?: BasicUserCredentials,
    refreshable?: boolean,
    expiresAfter?: number,
  ): Promise<UserResponseType> {
    const anonymous = getAnonymousUser()
    const username = JSON.parse(anonymous)?.username || basicUserCredentials?.username
    const password = JSON.parse(anonymous)?.password || basicUserCredentials?.password

    return await authApi.post<UserResponseDataType>(
      `/tenants/sportworld/anonymous/login`,
      {
        refreshable,
        expiresAfter,
      },
      {
        auth: {
          username,
          password,
        },
      },
    )
  }

  static async refreshTokens(expiresAfter?: number): Promise<AxiosResponse<UserResponseDataType>> {
    const refreshToken = getRefreshToken()
    const accessToken = getAccessToken()
    const res = await authApi.post<UserResponseDataType>(
      `/refresh`,
      {
        refreshToken,
        accessToken,
        expiresAfter,
      },
      {},
    )

    return res
  }
}
